/**
 * @author xiaohuangmaoth
 * @description 考试天天学练报表统计
 * @Date 2022/08/31
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool,utils_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import {examEverydayRecordExcelColumns} from './column';
import moment from "moment";

const { WizContainer, WizReduxTemplate } = framework_tool;
import { WizAuthority } from "@/containers/common";
let {
  WizBrowserExport,WizRow, WizCol, WizTable, WizCard, WizSpin, WizTabs, WizTag, WizMenu, WizButton,WizTooltip,WizTypography
} = component_tool;
const { Title, Text, Paragraph } = WizTypography
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterDateTime_ = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
let {Session} = utils_tool;
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/examRecordStatistics/examEverydayStatistics/showScore') {
      if (history.location && history.location.record) {
        record = {...history.location.record};
        Session.set('examEverydayDetailRecord', record)
      } else {
        record = Session.get('examEverydayDetailRecord') || 0
      }
    }
  } else {
    record = Session.get('examEverydayDetailRecord') || 0
  }
  return record
}

class ExamEverydayRecordStatistics extends WizContainer {
  componentName = "ExamEverydayRecordStatistics";
  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
    this.initialValue = getParamRecord(props.history);
  }
  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        pass: val.pass !==null && val.pass ===0 ? '未通过' : val.pass !==null && val.pass ===1 ? '通过': '未参考',
        orgName:val.orgNodeTypeName ===null || val.orgNodeTypeName !=='新能源组' ? val.orgName : val.parentOrgName,
        orgCode:val.orgNodeTypeName ===null || val.orgNodeTypeName !=='新能源组' ? val.orgCode : val.parentOrgCode,
        markingDate: formatterDateTime_(val.markingDate),
      }))
      const title = '天天学练考试明细'
      let dateTime = formatterDateTime(new Date());
      WizBrowserExport({
        title,
        sheetName: title,
        columns: examEverydayRecordExcelColumns.filter((_, index) => index),
        rows,
        filename: title +'_' +dateTime+'.xlsx',
      })
      return true
    } else {
      wizNotice.error(msg)
      return false;
    }

  }


  /**
   * 头部：名称
   */
  _header = ( title, value) => {
    return (
      <WizRow className='administrationScope-row-item'  style={{padding:0,marginLeft:"100px"}}>
        <WizCol className='col-item' span={2}>
          <Text strong >
            {title[0]}：
          </Text>
        </WizCol>
        <WizCol span={6}>
          <Text strong >
            {value[0]}
          </Text>
        </WizCol>
        <WizCol className='col-item' span={2}>
          <Text strong >
            {title[1]}：
          </Text>
        </WizCol>
        <WizCol span={6}>
          <Text strong >
            {value[1]}
          </Text>
        </WizCol>
        <WizCol className='col-item' span={2}>
          <Text strong >
            {title[2]}：
          </Text>
        </WizCol>
        <WizCol span={6}>
          <Text strong >
            {value[2]}
          </Text>
        </WizCol>
      </WizRow>
    )
  };

  _render() {
    const { id,title,categoryInfoName,startDate,endDate,targetScope } = this.initialValue;
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
      examId:id,
    });
    let title_ = ['考试名称','考试分类','考试时间'];
    let value = [title,categoryInfoName,formatterDateTime_(startDate)+'-'+formatterDateTime_(endDate)];
    return (
      <>
        <WizCard title={'考试信息'} key={'examInfo_'+new Date().getTime()} bodyStyle={{paddingLeft:20,paddingBottom:25,paddingTop:25}}>
          {this._header(title_,value)}
          <WizRow className='administrationScope-row-item' style={{padding:0,marginLeft:"100px",marginTop:"20px"}}>
            <WizCol className='col-item' span={2}><Text strong > {'受众范围'}：</Text></WizCol>
            <WizCol>
              <WizAuthority value={targetScope} mode='Button' />
            </WizCol>
          </WizRow>
        </WizCard>
        <WizCard title={'考试成绩明细'} key={'examRecord_'+new Date().getTime()}>
          <WizReduxTemplate {..._reduxTemplateCofig} />
        </WizCard>
      </>
    )
  }
}

export default connect(() => ({}))(ExamEverydayRecordStatistics);
